function Footer() {
    const year =  new Date().getFullYear();

    return (
      <div className="footer-container">
          <small>© {year} Bleu Fox Bakery</small>
      </div>
    );
  }

  export default Footer;